import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HitmakerService {

  constructor(private http: HttpClient) { }

  postHitmakerUploadVideo(movieId: any, stageName: any, data: any, formData: FormData): Observable<any> {
    let queryParams = new HttpParams()
      .set('urlAddress', data.url)
      .set('contentLabel', data.title)
      .set('order', String(data.order));

    const url = environment.apiURL + `api/hitmaker/${movieId}/stage/${stageName}/upload`;

    return this.http.post(url, formData, {
      params: queryParams,
      responseType: 'text'
    });
  }

  updateHitmakerStageData(movieId: any, stageId: any, data: any, formData: FormData): Observable<any> {
    let queryParams = new HttpParams()
      .set('urlAddress', data.url)
      .set('contentLabel', data.title)
      .set('order', String(data.order));

    const url = environment.apiURL + `api/hitmaker/${movieId}/stage/${stageId}/update`;

    return this.http.post(url, formData, {
      params: queryParams,
      responseType: 'text'
    });
  }

  getHitmakerStageDetails(movieId: any, stageName: any) {
    const url = environment.apiURL + `api/hitmaker/${movieId}/${stageName}`;
    return this.http.get(url);
  }
  getContestAssociated(movieId: any, stage: any) {
    const url = environment.apiURL + `api/hitmaker/${movieId}/${stage}`;
    return this.http.get(url);
  }

  deleteStageContent(stageId: any) {
    const url = environment.apiURL + 'api/delete-stage-content';
    const stageContent = { id: stageId };
    return this.http.post(url, stageContent);
  }

  hideStageContent(stageId: any, hiddenValue: any){
    const url = environment.apiURL + 'api/show-hide-stage-content';
    const stageContent = { id: stageId, hidden: hiddenValue };
    return this.http.post(url, stageContent);
  }

  upvoteStageContent(stageId: any){
    const url = environment.apiURL + 'api/upvote-stage-content';
    const stageContent = { id: stageId };
    return this.http.post(url, stageContent);
  }

  getUserUpvoteBalnce(){
    const url = environment.apiURL + 'api/userUpvoteBalance';
    return this.http.get(url);
  }

  getHitmakerStageData(movieId: any, stageName: any, stageId: any) {
    const url = environment.apiURL + `api/hitmaker/${movieId}/${stageName}/${stageId}`;
    return this.http.get(url);
  }
  getContestFilmDetails(){
    const url = environment.apiURL + `api/contests`;
    return this.http.get(url);
  }
}
